import React from 'react';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import type { SelectForColumnCellProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select/types';
import GenericReadonlyCell from '../generic-readonly-cell';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

export default function FieldSelectContent({ value }: SelectForColumnCellProps) {
	const item = Array.isArray(value) ? value[0] : value;
	return (
		<GenericReadonlyCell
			text={isDefined(item) && isDefined(item.label) ? item.label : ''}
			iconBefore={
				isDefined(item) && isDefined(item.icon) ? (
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					<img alt="" className={styles.readOnlyCellIcon} src={item.icon} />
				) : undefined
			}
		/>
	);
}
